import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'sl-typography',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sl-typography.component.html',
  styleUrl: './sl-typography.component.scss',
})
export class SlTypographyComponent {
  @Input()
  fontFamily: 'primary' | 'secondary' | 'italic' = 'primary';
  @Input() icon?: string;
  @Input()
  variant:
    | 'd1'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'body-10'
    | 'body-20'
    | 'body-30'
    | 'label'
    | 'input'
    | 'button-10'
    | 'button-20'
    | 'b1'
    | 'h1-d1'
    | 'h2-fce'
    | 'h3-fce'
    | 'li-body-20'
    | 'q'
    | 'q2'
    | 'assistive' = 'body-20';
  @Input()
  weight: 'light' | 'regular' | 'medium' | 'bold' | 'italic' = 'regular';
  @Input()
  color = '#1c1c1c';
  @Input({ required: true })
  text!: string;
  @Input()
  moreStyle:
    | 'description-body'
    | 'description-card'
    | 'description-collapsable'
    | 'content-text-list'
    | '' = '';
}
